import { AddChallengeToPatientPayload, Challenge } from '_api/types';
import DefaultChallengeToPatientSettings from '_constants/object-templates/DefaultChallengeToPatientSettings';

export function buildChallengePayload(
  id: number,
  patientId: number | '',
  challenge: Challenge | undefined,
): AddChallengeToPatientPayload {
  return {
    ...DefaultChallengeToPatientSettings,
    contentId: id,
    patientId,
    instructionList: [...(challenge?.instructionList ?? [])],
    defaultTargetSide:
      typeof challenge?.targetSide === 'string'
        ? challenge.targetSide
        : challenge?.targetSide?.name ?? 'NA',
  };
}
